import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import type { FeedbackCollection } from './feedback.types';

export function feedbackReducer(
  state: CollectionStateSlice<FeedbackCollection> = {},
  action: CollectionActions<FeedbackCollection>,
): CollectionStateSlice<FeedbackCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      return state;
    }

    default:
      return state;
  }
}
